"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.mapGXKeyToEHRField = exports.getUpdatedLinkedGXAnswers = exports.getGXDataForEHR = exports.getEHRBoundGXData = exports.formatGXDataForEHR = exports.formFieldsFromGxAnswers = exports.buildLinkedGXAnswerFields = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _transform = _interopRequireDefault(require("lodash/transform"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _gx = require("./constants/gx");
/**@summary Uses gx answers to populate fields in the patient form.
 * @description Processes data from the `visible` field from `linkedGxAnswers` but not the `hidden` field.
 * `visible` data is used to populate certain fields in the patientReg form.
 * If a user answers a DOB question from GX,
 * that data should be auto-filled when they get to the patientReg form.
 * This is done by linking answers from each to a `path` variable like `patient.dob` */
const formFieldsFromGxAnswers = linkedGxAnswers => {
  const {
    visible
  } = linkedGxAnswers;
  const fields = {};
  if (visible) {
    for (const key in visible) {
      fields[key] = {
        value: visible[key],
        errors: []
      };
    }
  }
  return fields;
};

/**GX questions-answers such as telehealth attestation may have a flag `sendToEHR: true`,
 * and this use case should be hidden from the consumer.
 * So these values will bypass registration form UI in DBW and
 * be passed as a field to Scheduling upon booking appointment.
 * @returns {Object} GX Data to be sent to EHR */
exports.formFieldsFromGxAnswers = formFieldsFromGxAnswers;
const getEHRBoundGXData = linkedGxAnswers => linkedGxAnswers.hidden || {};
exports.getEHRBoundGXData = getEHRBoundGXData;
const mapGXKeyToEHRField = gxKey => {
  const ehrSupportedGXQuestion = (0, _find.default)(_gx.EHR_SUPPORTED_GX_QUESTIONS).call(_gx.EHR_SUPPORTED_GX_QUESTIONS, q => q.name == gxKey);
  return ehrSupportedGXQuestion?.ehrField || gxKey;
};

/**@summary Formats GX Data to be sent to EHR.
 * @description There are character limits in the EHR appointment notes field,
 * so an answer value should be shortened to be respectful of resources.
 *     - Each EHR platform has different character limits.
 *     - For more, see: https://kyruus.jira.com/wiki/spaces/AHC/pages/331677967/How+To+Sending+Registration+Data+in+Appointment+Notes
 * @returns {Object} GX data formatted for EHR */
exports.mapGXKeyToEHRField = mapGXKeyToEHRField;
const formatGXDataForEHR = gxData => {
  const transformAnswerValues = (result, value, key) => {
    const shortenedYesNoAnswer = (0, _includes.default)(_gx.YES_NO_ANSWERS).call(_gx.YES_NO_ANSWERS, value) && value.charAt(0);
    const updatedKey = mapGXKeyToEHRField(key);
    result[updatedKey] = shortenedYesNoAnswer || value;
  };
  return (0, _transform.default)(gxData, transformAnswerValues, {});
};

/**Gets EHR-bound GX questions, then processes for correct EHR formatting. */
exports.formatGXDataForEHR = formatGXDataForEHR;
const getGXDataForEHR = linkedGxAnswers => {
  const ehrBoundGXData = getEHRBoundGXData(linkedGxAnswers);
  return formatGXDataForEHR(ehrBoundGXData);
};

/**Immutably updates `linkedGxAnswers`. */
exports.getGXDataForEHR = getGXDataForEHR;
const getUpdatedLinkedGXAnswers = (steps, linkedGxAnswers) => {
  var _context;
  const linkedGxAnswersCopy = (0, _cloneDeep.default)(linkedGxAnswers);
  const updatedLinkedGxAnswers = (0, _reduce.default)(_context = (0, _map.default)(steps).call(steps, buildLinkedGXAnswerFields)).call(_context, (prev, cur) => {
    return (0, _merge.default)(prev, cur);
  }, linkedGxAnswersCopy);
  return updatedLinkedGxAnswers;
};

/**@summary Builds `linkedGxAnswers` for a given GX `step`.
 * @description Sets the `hidden` field when given a `step` with property `sendToEHR: true`. Otherwise, the `visible` field will be set. */
exports.getUpdatedLinkedGXAnswers = getUpdatedLinkedGXAnswers;
const buildLinkedGXAnswerFields = step => {
  if (step?.sendToEHR) return setHiddenField(step);
  return setVisibleField(step);
};

/**Sets `hidden` field for `linkedGXAnswers` of a given GX `step`. */
exports.buildLinkedGXAnswerFields = buildLinkedGXAnswerFields;
const setHiddenField = step => ({
  hidden: {
    [step.name]: step.answer
  }
});

/**Sets `visible` field for `linkedGXAnswers` of a given GX `step`. */
const setVisibleField = step => {
  const isDOBQuestion = step?.control?.path;
  if (isDOBQuestion) {
    const {
      answer,
      control
    } = step;
    const {
      path
    } = control;
    return {
      visible: {
        [path]: answer
      }
    };
  }
  return {};
};